import script from "./Accounts.vue?vue&type=script&setup=true&lang=js"
export * from "./Accounts.vue?vue&type=script&setup=true&lang=js"

import "./Accounts.vue?vue&type=style&index=0&id=177a8f21&lang=css"

const __exports__ = script;

export default __exports__